var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdhocMeeting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.367,
    height: 16.155,
    viewBox: "0 0 18.367 16.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29237",
    "data-name": "Group 29237",
    transform: "translate(-2182.75 -382.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48754",
    "data-name": "Path 48754",
    d: "M2314.574,651.561h-15.457a.344.344,0,1,1,0-.689h15.457a.344.344,0,0,1,0,.689Z",
    transform: "translate(-114.051 -264.369)",
    fill: "#4a8409",
    stroke: "#4a8409",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48755",
    "data-name": "Path 48755",
    d: "M2367.208,385.227a.344.344,0,0,1-.344-.344v-2.025a.344.344,0,1,1,.688,0v2.025A.344.344,0,0,1,2367.208,385.227Z",
    transform: "translate(-181.131 0)",
    fill: "#4a8409",
    stroke: "#4a8409",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48756",
    "data-name": "Path 48756",
    d: "M2563.368,385.227a.344.344,0,0,1-.344-.344v-2.025a.344.344,0,1,1,.688,0v2.025A.344.344,0,0,1,2563.368,385.227Z",
    transform: "translate(-374.365 0)",
    fill: "#4a8409",
    stroke: "#4a8409",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48757",
    "data-name": "Path 48757",
    d: "M2759.528,385.227a.344.344,0,0,1-.344-.344v-2.025a.344.344,0,1,1,.688,0v2.025A.344.344,0,0,1,2759.528,385.227Z",
    transform: "translate(-567.604 0)",
    fill: "#4a8409",
    stroke: "#4a8409",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48758",
    "data-name": "Path 48758",
    d: "M2955.687,385.227a.344.344,0,0,1-.344-.344v-2.025a.344.344,0,1,1,.688,0v2.025A.344.344,0,0,1,2955.687,385.227Z",
    transform: "translate(-760.843 0)",
    fill: "#4a8409",
    stroke: "#4a8409",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48759",
    "data-name": "Path 48759",
    d: "M3153.208,385.227a.344.344,0,0,1-.344-.344v-2.025a.344.344,0,1,1,.688,0v2.025A.344.344,0,0,1,3153.208,385.227Z",
    transform: "translate(-955.417 0)",
    fill: "#4a8409",
    stroke: "#4a8409",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48760",
    "data-name": "Path 48760",
    d: "M2198.86,441.116h-13.873a1.988,1.988,0,0,1-1.988-1.985V428.094a1.988,1.988,0,0,1,1.988-1.985h1.094a.344.344,0,1,1,0,.689h-1.094a1.3,1.3,0,0,0-1.3,1.3v11.038a1.3,1.3,0,0,0,1.3,1.3h13.873a1.309,1.309,0,0,0,1.318-1.3V428.094a1.323,1.323,0,0,0-1.178-1.3.344.344,0,1,1,.084-.684,2.013,2.013,0,0,1,1.783,1.982v11.038A2,2,0,0,1,2198.86,441.116Zm-1.074-14.318h-1.663a.344.344,0,1,1,0-.689h1.663a.344.344,0,0,1,0,.689Zm-2.941,0H2193.2a.344.344,0,1,1,0-.689h1.642a.344.344,0,1,1,0,.689Zm-2.921,0h-1.643a.344.344,0,0,1,0-.689h1.643a.344.344,0,1,1,0,.689Zm-2.921,0h-1.642a.344.344,0,1,1,0-.689H2189a.344.344,0,1,1,0,.689Z",
    transform: "translate(0 -42.948)",
    fill: "#4a8409",
    stroke: "#4a8409",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48761",
    "data-name": "Path 48761",
    d: "M2571.4,825.089h-1.924a.344.344,0,0,1-.344-.344c0-2.235-.026-1.553-.811-1.7h-.871a.344.344,0,0,1-.344-.344v-1.9a.344.344,0,0,1,.344-.344h1.682v-1.7a.344.344,0,0,1,.344-.344h1.924a.344.344,0,0,1,.344.344v1.7h1.681a.344.344,0,0,1,.344.344v1.9a.344.344,0,0,1-.344.344h-1.681v1.7A.344.344,0,0,1,2571.4,825.089Z",
    transform: "translate(-378.383 -429.411)",
    fill: "#4a8409"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdhocMeeting);
export default __webpack_public_path__ + "static/media/adhoc-meeting.caddcdb2.svg";
export { ForwardRef as ReactComponent };